import { Spinner } from '../ui/spinner';

export function LoadingScreen() {
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center gap-4 bg-[var(--bg-root)]">
      <Spinner className="size-8 border-[3px]" />
      <p className="text-xs text-[var(--text-muted)]">読み込み中...</p>
    </div>
  );
}
